var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevrondown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m47.6 17.8l-20.5 20.7c-0.6 0.6-1.6 0.6-2.2 0l-20.5-20.7c-0.6-0.6-0.6-1.6 0-2.2l2.2-2.2c0.6-0.6 1.6-0.6 2.2 0l16.1 16.3c0.6 0.6 1.6 0.6 2.2 0l16.1-16.2c0.6-0.6 1.6-0.6 2.2 0l2.2 2.2c0.5 0.6 0.5 1.5 0 2.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrondown);
export default __webpack_public_path__ + "static/media/chevrondown.748c5578ec7318854c1a9ffa3af08c8b.svg";
export { ForwardRef as ReactComponent };